// extracted by mini-css-extract-plugin
export default {"root":"ErrorRetry__root--3bVtO","centered":"ErrorRetry__centered--3NIRz","text":"ErrorRetry__text--2fTSt"};